import * as yup from "yup";

export const sponsorValidator = yup.object({
  email: yup.string().required().email(),
  firstname: yup.string().required(),
  lastname: yup.string().required(),
  //   amount: yup.string().required(),
});
